// extracted by mini-css-extract-plugin
module.exports = {"hrContainer":"holdingRegister_hrContainer__3Udgk","actions":"holdingRegister_actions__2sCQz"};